import { Modal } from "antd";
import "./HelpModal.css";

const HelpModal = ({ visible, onCancel }) => {
  return (
    <>
      <Modal
        className="help-modal"
        title="Guide"
        onCancel={onCancel}
        open={visible}
        width="35vw"
        style={{ minWidth: 280 }}
        centered
        zIndex={1000}
        destroyOnHidden
        footer={null}
      >
        This is an interactive website where you can play around with *mostly*
        everything. Try the folders and the songs though, I put a lot of efforts
        into those.
      </Modal>
    </>
  )
};

export default HelpModal;
